// extracted by mini-css-extract-plugin
export default {"userPicWrapper":"UserPic_userPicWrapper__OvS9N","userPicInner":"UserPic_userPicInner__tpGNj"};